import { GraphChartConfigDto, ScatterChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import ScatterChart from 'components/Charts/ScatterChart/ScatterChart';
import { useTranslation } from 'react-i18next';
import useScatterChartData from 'hooks/useScatterChartData';

const ReportScatterChart = ({ chartData, isLoading, chartConfig }: ChartProps<ScatterChartDataDto, GraphChartConfigDto>) => {
  const { t } = useTranslation();

  const scatterChartData = useScatterChartData(chartData?.datasets, isLoading);

  return <ScatterChart xLabel={t(chartConfig.xAxis)} yLabel={t(chartConfig.yAxis)} chartData={scatterChartData} />;
};

export default ReportScatterChart;
